import React from 'react';
import { useLayoutContext } from '../Contexts/LayoutContext';
import DefaultLayout from '../Layouts/DefaultLayout';
import Fidelity from './Fidelity';

const FidelityPage = () => {

    const { isMobile } = useLayoutContext();

    return (
        <DefaultLayout showHeader={!isMobile}>
            {/* <section className=''> */}
                <Fidelity />
            {/* </section> */}
        </DefaultLayout>
    );
};

export default FidelityPage;
